import React, { Fragment } from "react"
import styled from "styled-components"
import {
  fetchData,
  removeData,
  showToast,
  setHeaderTitle,
  saveData,
  showPopup,
  hidePopup,
} from "../../store/action"
import PageHeader from "../PageHeader"
import HorizontalScroll from "../../components/horizontalScroll/HorizontalScroll"
import { Card } from "../../components/horizontalScroll/Card"
import { trendingBids } from "../../dummyData"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import { replaceWithSymbol } from "../../util/cutString"
import { secondsToHms } from "../../util/Utility"
import i18n from "../../i18n"

const InnerWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 56px);
  box-sizing: border-box;
`

class AllBids extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mainLoader: true,
    }
  }

  loadData() {
    console.log("offers Auctions load data")
    const { fetchData, uniqueId, saveData } = this.props
    fetchData({
      uniqueId,

      method: "GET",
      uri: `/offers`,
      onSuccess: (res) => {
        console.log(res.auctionDetailsDTO.auction)
        if (res && res.auctionDetailsDTO && res.auctionDetailsDTO.auction) {
          this.setState({
            mainLoader: false,
            bids: res.auctionDetailsDTO.auction,
          })
        } else {
          this.setState({ mainLoader: false, bids: [] })
        }
        console.log("bids", this.state.bids)
      },
    })
  }

  bidClickHanlder = (offerTitle, offerId) => {
    this.props.history.push(
      `/play/product-details/${replaceWithSymbol(offerTitle)}/${offerId}`
    )
  }

  componentDidMount() {
    this.loadData()
  }

  render() {
    const { bids, mainLoader } = this.state
    const { history, theme } = this.props
    //  if(mainLoader){
    //    return null;
    //  }
    const trendingBids = bids  && bids.filter((fl) => fl.isTrending === true)
    const weeklyBids = bids && bids.filter((fl) => fl.isWeekly === true)
    const dailyBids = bids && bids.filter((fl) => fl.isDaily === true)

    console.log("bids", bids)
    return (
      <Fragment>
        <PageHeader backLocation={"/play/"} label={"All Bids"} theme={theme} />
        <InnerWrapper
          style={{ backgroundColor: theme ? theme.secondaryColor : "#ccc" }}
        >
          {trendingBids && trendingBids.length > 0 && (
            <HorizontalScroll
              bidsType='isTrending'
              title={i18n.t("TrendingBids")}
              seeAllHandler={() => history.push("/play/trending-bids")}
              bids={bids}
              onClick={this.bidClickHanlder}
              theme={theme}
            />
          )}
          {dailyBids && dailyBids.length > 0 && (
            <HorizontalScroll
              bidsType='isDaily'
              title={i18n.t("DailyBids")}
              seeAllHandler={() => history.push("/play/daily-bids")}
              bids={bids}
              onClick={this.bidClickHanlder}
              theme={theme}
            />
          )}
          {weeklyBids && weeklyBids.length > 0 && (
            <HorizontalScroll
              bidsType='isWeekly'
              title={i18n.t("WeeklyBids")}
              seeAllHandler={() => history.push("/play/weekly-bids")}
              bids={bids}
              onClick={this.bidClickHanlder}
              theme={theme}
            />
          )}
        </InnerWrapper>
        {/* // </div> */}
      </Fragment>
    )
  }
}

AllBids = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      ;(mapStateToProps.data = state.data[ownProps.uniqueId]),
        (mapStateToProps.theme = state.theme)
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    setHeaderTitle,
    saveData,
    showPopup,
    hidePopup,
  }
)(withRouter(translate("translations")(AllBids)))
export default AllBids



// WEBPACK FOOTER //
// ./src/views/AllBids/index.js